import { Colors } from '../../../theme/colors';
import { StatusBadge } from '../status-badge/status-badge.component';
import { StatusWarning } from '../icons/StatusWarning.icon';

export interface NeedsReviewBadgeProps {
  label: string;
  tooltipLabel?: string;
}

/** A set width stops a flex column parent, such as a table cell group, stretching it. */
const hugLabel = { width: 'fit-content' } as const;

/** Shaped as `UserStatusBadge condensed`, in informative yellow rather than a status colour. */
export const NeedsReviewBadge = ({ label, tooltipLabel }: NeedsReviewBadgeProps) => (
  <StatusBadge
    label={label}
    style={hugLabel}
    color={Colors.informativeYellow}
    fontColor={Colors.burntOrange}
    Icon={StatusWarning}
    iconSize="18px"
    cornerRounding="med"
    fontSize="13px"
    collapse="wrap-sides"
    desktopHeight="24px"
    capitalize
    showTooltip={!!tooltipLabel}
    tooltipLabel={tooltipLabel}
    tooltipPlacement="bottom"
  />
);
